import Slider from "rc-slider";
import React, {useContext, useEffect, useState} from "react";
import Button from "../../../Components/Button";
import {formatPrice, getConfiguredPaymentLink, getPriceDays, IPriceInfo, usePayment} from "../../../Hooks/usePayment";
import {Icon, Popup} from "semantic-ui-react";
import keys from "../../../translations/keys";
import { useTranslation } from "react-i18next";
import { LanguageContext } from "../../../Context/LanguageContext";
import {Link, useLocation} from "react-router-dom";
// @ts-ignore
import AnimatedNumber from "animated-number-react";
import {DataContext} from "../../../Context/DataContext";
import PaypalButton from "../../../Components/PaypalButton";
import _ from "underscore";
import useAuth from "../../../Hooks/useAuth";
import "../../../Styles/SubscriptionPrices.scss";

export type IBuySubBlockProps = {};


const BuySubBlock = ({}: IBuySubBlockProps) => {
    const {isLoading: isPricesLoading, prices} = useContext(DataContext);
    const { isLoading, getPaymentLink } = usePayment();
    const [price, setPrice] = useState(0);
    const [shopiData, setShopiData] = useState('');
    const {claims} = useAuth();
    const claimsToHave = ['r_devpanel_in_loader']
    const hasClaims = claimsToHave ? _.every(claimsToHave, x => _.contains(claims, x)) : true;
    const [selectedPlanIndex, setSelectedPlanIndex] = useState(0);
    const lables = prices?.map((_, index) => index) ?? [];
    // const [prices, setPrices] = useState([] as IPriceInfo[]);
    const [selectedPrice, setSelectedPrice] = useState({} as IPriceInfo);
    // const [checkout, setCheckout] = useState({} as any);
    // const {onOpen, isOpen, onToggle, onClose} = useModalState();
    const {t} = useTranslation();
    // const location = useLocation();

    const { lang } = useContext(LanguageContext);

    useEffect(() => {
        if (prices && prices.length > 0) {
            const monthIndex = prices.findIndex(item => getPriceDays(item) === 30);
            const index = monthIndex >= 0 ? monthIndex : 0;
            const selected = prices[index];
            setSelectedPlanIndex(index);
            setSelectedPrice(selected);
            setPrice(selected.usdPrice);
        }
    }, [prices]);

    const priceTable = prices ?? [];

    const openPayment = async (provider: string) => {
        const link = getConfiguredPaymentLink(selectedPrice, provider);
        if (!link) return;
        const url = link.isGenerated ? await getPaymentLink(link.url) : link.url;
        if (typeof url !== 'string') return;
        try {
            const target = new URL(url);
            if (target.protocol === 'https:') window.location.href = target.href;
        } catch {
            return;
        }
    }

    const sendToPayment = () => openPayment('FreeKassa');
    const digiHandler = () => openPayment('Digiseller');
    const funPayHandler = () => openPayment('FunPay');

    const onChange = (value: number | number[]) => {
        const index = value as number;
        const selected = priceTable[index];
        if (!selected) return;
        setSelectedPlanIndex(index);
        setSelectedPrice(selected);
        setPrice(selected.usdPrice);
    };

    const getMarks = () => {
        const marks: Record<number, React.ReactNode> = {};
        lables.forEach(item => {
            const selected = priceTable[item];
            const days = selected.days;
            const bonus = typeof days === 'object' ? days.bonus : undefined;
            marks[item] = <div className="daysContainer">
                {t(keys.day.day, {count: getPriceDays(selected)})}
                {bonus && <div className="daysContainer__bonus">{`+${bonus}%`}</div>}
            </div>;
        });
        return marks;
    };

    const paymentLinkHandler = (provider: 'Card' | 'Paypal' | 'Crypto') => openPayment(provider);

    const paypalLinkHandler = () => {
        // window.location.href = 'https://www.paypal.com/paypalme/Jumpering'
        // window.location.href = 'https://Paypal.me/mralphm'
        window.location.href = 'https://discord.com/channels/721518056416739388/857952386769485835/968029775337758731'
        // window.location.href = 'https://paypal.me/DivineDota'
    }

    const discordLinkHandler = () => {
        window.open('https://discord.gg/YvFuC6H');
    }
    const chinaLinkHandler = () => {
        window.open('https://qm.qq.com/q/WHlyvrkOcw');
    }

    const info = () => {
        return <Popup content={<div className="block-buy_sub__popup">
            <div className="block-buy_sub__popup--title">
                {t(keys.mainPage.paymentBlock.tooltip.title)}
            </div>
            <div className="block-buy_sub__popup--content">
                <div className="row">* {t(keys.mainPage.paymentBlock.tooltip.row1)}</div>
                <div className="row">* {t(keys.mainPage.paymentBlock.tooltip.row2)}</div>
                <div className="row">* {t(keys.mainPage.paymentBlock.tooltip.row3)}</div>
            </div>
            <div className="block-buy_sub__popup--content-extra">
                <div className="row">{t(keys.mainPage.paymentBlock.tooltip.extra)}</div>
            </div>
        </div>} trigger={<Icon name={'question circle'}/>} position={'bottom center'}/>
    }

    // return <Block title={t(keys.mainPage.paymentBlock.title)} hideScrollbars className={'block-buy_sub'}
    //               info={info()}>

    return <>
        <div className="content">

            <div className="price-info">
                <div className="info">{t(keys.mainPage.paymentBlock.amount)}</div>
                <div className="prices">
                    {price > 0 && !selectedPrice.isCis && <>
                        <AnimatedNumber
                            className="price"
                            value={price}
                            formatValue={(value: string) => `$ ${Number(value).toFixed(2)}`}
                            duration={100}
                        />
                        {selectedPrice.discount >= 0 && <AnimatedNumber
                            className="price price--discount"
                            value={selectedPrice.discount}
                            formatValue={(value: string) => `${t(keys.mainPage.paymentBlock.discount)}: ${Number(value).toFixed(0)}%`}
                            duration={100}
                        />}

                    </>}
                    {selectedPrice?.price > 0 && selectedPrice.isCis && <>
                        <AnimatedNumber
                            className="price"
                            value={selectedPrice?.price}
                            formatValue={(value: string) => `${Number(value).toFixed(0)}₽`}
                            duration={100}
                        />
                        {selectedPrice.discount >= 0 && <AnimatedNumber
                            className="price price--discount"
                            value={selectedPrice.discount}
                            formatValue={(value: string) => `${t(keys.mainPage.paymentBlock.discount)}: ${Number(value).toFixed(0)}%`}
                            duration={100}
                            />}
                    </>}
                    {/*<div className="price">${price} usd</div>*/}
                    {/*<div className="price">{selectedPrice.price} ₽</div>*/}
                </div>
                {selectedPrice.id && <span className="subscription-price-per-day">{t(keys.pricing.dailyAmount, {amount: formatPrice(selectedPrice, true)})}</span>}
            </div>
            {/*<Popup trigger={<Button circular className={'paymentBtn'}*/}
            {/*                        onClick={sendToPaymentPaymaster}>{t(keys.mainPage.paymentBlock.paymaster.btn)}</Button>}*/}
            {/*       content={t(keys.mainPage.paymentBlock.paymaster.tooltip)} position={'top center'}/>*/}

            <Popup trigger={<Button disabled={!getConfiguredPaymentLink(selectedPrice, 'Card')} circular onClick={() => paymentLinkHandler('Card')}>{t(keys.mainPage.paymentBlock.payment.btn)}</Button>}
                content={t(keys.mainPage.paymentBlock.payment.tooltip)} position={'top center'} />
            <Popup trigger={<Button disabled={!getConfiguredPaymentLink(selectedPrice, 'Paypal')} circular onClick={() => paymentLinkHandler('Paypal')}>{t(keys.mainPage.paymentBlock.paypal.btn)}</Button>}
                content={t(keys.mainPage.paymentBlock.paypal.tooltip)} position={'top center'} />
            <Popup trigger={<Button disabled={!getConfiguredPaymentLink(selectedPrice, 'Crypto')} circular onClick={() => paymentLinkHandler('Crypto')}>{t(keys.mainPage.paymentBlock.crypto.btn)}</Button>}
                content={t(keys.mainPage.paymentBlock.crypto.tooltip)} position={'top center'} />
            <Popup trigger={<Button disabled={!getConfiguredPaymentLink(selectedPrice, 'FunPay')} circular onClick={funPayHandler}>{t(keys.mainPage.paymentBlock.funPay.btn)}</Button>}
                   content={t(keys.mainPage.paymentBlock.funPay.tooltip)} position={'top center'} />
            <Popup trigger={<Button disabled={!getConfiguredPaymentLink(selectedPrice, 'FreeKassa')} circular onClick={sendToPayment}>{t(keys.mainPage.paymentBlock.freeKassa.btn)}</Button>}
                   content={t(keys.mainPage.paymentBlock.freeKassa.tooltip)} position={'top center'} />
            {/*<Popup trigger={<Button disabled={!prices?.length} circular onClick={paymaxHandler}>{t(keys.mainPage.paymentBlock.paymax.btn)}</Button>}*/}
            {/*       content={t(keys.mainPage.paymentBlock.paymax.tooltip)} position={'top center'} />*/}
            <Popup trigger={<Button disabled={!getConfiguredPaymentLink(selectedPrice, 'Digiseller')} circular onClick={digiHandler}>{t(keys.mainPage.paymentBlock.payDigi.btn)}</Button>}
                   content={t(keys.mainPage.paymentBlock.payDigi.tooltip)} position={'top center'} />
            {Object.keys(selectedPrice?.paymentLinks ?? {}).filter(provider =>
                !['Card', 'Paypal', 'Crypto', 'FunPay', 'FreeKassa', 'Digiseller'].includes(provider)
            ).map(provider => <Button key={provider} circular disabled={!getConfiguredPaymentLink(selectedPrice, provider)}
                                      onClick={() => openPayment(provider)}>{provider}</Button>)}
            {/*<Popup trigger={<Button disabled={!prices?.length} circular onClick={primePaymentsHandler}>{t(keys.mainPage.paymentBlock.primePayments.btn)}</Button>}*/}
            {/*       content={t(keys.mainPage.paymentBlock.primePayments.tooltip)} position={'top center'}/>*/}
            {/*<Popup trigger={<Button disabled={!prices?.length} circular>Paypal Reseller</Button>}*/}
            {/*       on={['click']}*/}
            {/*       content={component => {*/}
            {/*           return <div className="popup-paypal-content">*/}
            {/*               {t(keys.mainPage.paymentBlock.paypal.tooltip)}*/}
            {/*               <Button onClick={paypalLinkHandler} disabled={!prices?.length} color={'orange'}>Discord Ticket</Button>*/}
            {/*           </div>*/}
            {/*       }} position={'top center'}/>*/}
            {/*<Popup trigger={<Button disabled={!prices?.length} circular>Paypal/Stripe/Visa/MC Reseller</Button>}*/}
            {/*    on={['click']}*/}
            {/*    content={component => {*/}
            {/*        return <div className="popup-paypal-content">*/}
            {/*            {t(keys.mainPage.paymentBlock.paypal.tooltip)}*/}
            {/*            <Button onClick={paypalLinkHandler} disabled={!prices?.length} color={'orange'}>Discord Ticket</Button>*/}
            {/*        </div>*/}
            {/*    }} position={'top center'} />*/}
            {/*<Popup trigger={<Button circular>{t(keys.mainPage.paymentBlock.paypal.btn)}</Button>}*/}
            {/*       on={['click']}*/}
            {/*       content={component => {*/}
            {/*           return <div className="popup-paypal-content">*/}
            {/*               /!*{t(keys.mainPage.paymentBlock.paypal.tooltip)}*!/*/}
            {/*               /!*<Button onClick={paypalLinkHandler} color={'orange'}>Paypal.me/DivineDota</Button>*!/*/}
            {/*               <PaypalButton priceInfo={selectedPrice}/>*/}
            {/*           </div>*/}
            {/*       }*/}
            {/*       } position={'top center'}/>*/}
            {/*<Popup trigger={<Button disabled={!prices?.length} circular>{t(keys.mainPage.paymentBlock.reseller.btn)}</Button>}*/}
            {/*       on={['click', 'hover']} pinned hoverable*/}
            {/*       content={component => {*/}
            {/*           return <div className="popup-paypal-content">*/}
            {/*               {t(keys.mainPage.paymentBlock.reseller.tooltip)}*/}
            {/*               <Button onClick={discordLinkHandler} disabled={!prices?.length} color={'orange'}>Discord</Button>*/}
            {/*               */}{/*{t(keys.mainPage.paymentBlock.reseller.tooltip2)}*/}
            {/*               */}{/*<Button onClick={chinaLinkHandler} disabled={!prices?.length} color={'orange'}>Chinese Reseller</Button>*/}
            {/*               */}{/*<Link to="route" target="_blank" className="link" onClick={(event) => {*/}
            {/*               */}{/*    event.preventDefault();*/}
            {/*               */}{/*    window.open('https://discord.gg/YvFuC6H');*/}
            {/*               */}{/*}}>Discord</Link>*/}
            {/*           </div>*/}
            {/*       }} position={'top center'}/>*/}
            {/* <Popup trigger={<Button disabled={!prices?.length} circular onClick={chinaLinkHandler}>{t(keys.mainPage.paymentBlock.chineseReseller.btn)}</Button>}
                   content={t(keys.mainPage.paymentBlock.chineseReseller.tooltip)} position={'top center'}/> */}
        </div>
        {prices?.length > 0 && <div className="content--slider">
            <Slider min={0} max={priceTable.length - 1} value={selectedPlanIndex} step={null} onChange={onChange}
                    railStyle={{backgroundColor: '#f6f6f6'}}
                    dotStyle={{backgroundColor: '#29292970'}}
                    activeDotStyle={{backgroundColor: '#ffffff', borderColor: '#FF8E25'}}
                    trackStyle={{backgroundColor: '#FF8E25'}}
                    handleStyle={{backgroundColor: 'white', borderColor: '#FF8E25'}}
                    marks={getMarks()}/>
        </div>}

    </>
    // </Block>
}

export default BuySubBlock;
